<template>
  <div class="bg-gray-50 hover:bg-gray-100">
    <div
      class="text-center bg-gradient-to-r from-gray-800 via-gray-900 to-black"
    >
      <p class="text-xs font-extrabold tracking-tight text-gray-900 sm:text-lg">
        Services
      </p>
    </div>

    <div class="text-center">
      <!-- <i class="text-blue-500 fas fa-gears mr-2"></i> -->
      <h2 class="text-3xl font-extrabold tracking-tight sm:text-4xl">
        Services
      </h2>
      <p class="text-base sm:text-lg text-gray-500">
        If you have any questions, please contact us
      </p>
    </div>

    <div
      class="lg:w-10/12 md:w-full sm:w-full mx-auto py-4 px-4 sm:px-6 lg:px-8"
    >
      <mobile-services></mobile-services>
    </div>

    <div class="text-center bg-gray-900">
      <p class="text-sm font-extrabold tracking-tight text-gray-900 sm:text-lg">
        Services
      </p>
    </div>
  </div>
</template>
<script>
import MobileServices from "./MobileServices.vue";
export default {
  components: { MobileServices },
  props: ["userAuth"],
  methods: {
    redirectRental() {
      this.$router.push({ name: "rentals", params: { value: "true" } });
    },

    isManagement() {
      if (this.userAuth) {
        this.$router.push({ name: "listings" });
      } else {
        this.$router.push({
          name: "ManageRegister",
          params: { state: "Management" }
        });
      }
    },

    isSeller() {
      if (this.userAuth) {
        this.$router.push({ name: "listings" });
      } else {
        this.$router.push({
          name: "listingRegister",
          params: { state: "Seller" }
        });
      }
    },

    isBuyer() {
      if (this.userAuth) {
        this.$router.push({ name: "listings" });
      } else {
        this.$router.push({
          name: "BuyerRegister",
          params: { state: "Buyer" }
        });
      }
    }
  }
};
</script>
<style scoped lang="scss">
// base
.flip {
  position: relative;
  > .front,
  > .back {
    display: block;
    transition-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.275);
    transition-duration: 0.5s;
    transition-property: transform, opacity;
  }
  > .front {
    transform: rotateY(0deg);
  }
  > .back {
    position: absolute;
    opacity: 0;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    transform: rotateY(-180deg);
  }
  &:hover {
    > .front {
      transform: rotateY(180deg);
    }
    > .back {
      opacity: 1;
      transform: rotateY(0deg);
    }
  }
  &.flip-vertical {
    > .back {
      transform: rotateX(-180deg);
    }
    &:hover {
      > .front {
        transform: rotateX(180deg);
      }
      > .back {
        transform: rotateX(0deg);
      }
    }
  }
}

// custom
.flip {
  position: relative;
  display: inline-block;
  margin-right: 2px;
  margin-bottom: 1em;
  > .front,
  > .back {
    display: block;
    color: rgb(20, 20, 20);
    width: inherit;
    background-size: cover !important;
    background-position: center !important;
    padding: 1em 2em;
    background: #fafafa;
    border-radius: 10px;
    p {
      font-size: 0.9125rem;
      line-height: 160%;
      color: #999;
    }
  }
}
</style>
